import { useEffect, useRef, useState } from "react";
import {
  ChevronDown,
  CircleHelp,
  Moon,
  Shield,
} from "lucide-react";
import LogOutMethod from "../LogOut/LogOut";
import ChangePasswordModal from "./ChangePasswordModal";
import "./ChangePasswordModal.css";
import "./UserMenu.css";

const defaultAvatar = `${process.env.PUBLIC_URL}/default-avatar.svg`;

const menuSections = [
  {
    title: "Gestión de Cuenta",
    items: [
      //{ label: "Perfil", icon: User },
      { label: "Seguridad", icon: Shield },
      //{ label: "Facturación", icon: CreditCard },
    ],
  },
  {
    title: "Preferencias de la App",
    items: [
      //{ label: "Configuración", icon: Settings },
    //{ label: "Idioma", icon: Languages },
      { label: "Modo Oscuro", icon: Moon },
    ],
  },
  {
    title: "Ayuda y Soporte",
    items: [
      //{ label: "Documentación", icon: BookOpen },
      { label: "Soporte", icon: CircleHelp },
//      { label: "Acerca de", icon: UserRound },
    ],
  },
];

const getText = (...values) =>
  values.find((value) => typeof value === "string" && value.trim())?.trim() || "";

const UserMenu = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const menuRef = useRef(null);

  const name = getText(user?.full_name, user?.name, user?.username) || "Usuario";
  const email = getText(user?.email, user?.correo) || "Correo no disponible";
  const role = getText(
    user?.role_name,
    typeof user?.role === "string" ? user.role : user?.role?.name
  );
  const plan = getText(user?.plan_name, typeof user?.plan === "string" ? user.plan : user?.plan?.name);
  const accountDescription = [
    role && `Rol: ${role}`,
    plan && `Plan: ${plan}`,
  ].filter(Boolean).join(" · ") || "Rol: Usuario";
  const avatar = getText(
    user?.avatar_url,
    user?.avatar,
    user?.photo,
    user?.picture,
    user?.profile_picture,
    user?.image
  ) || defaultAvatar;

  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointerDown = (event) => {
      if (!menuRef.current?.contains(event.target)) setIsOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div className="user-menu" ref={menuRef}>
      <button
        type="button"
        className="user-menu-trigger"
        onClick={() => setIsOpen((open) => !open)}
        aria-label="Abrir menú de usuario"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <img
          src={avatar}
          alt=""
          className="user-menu-trigger-avatar"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = defaultAvatar;
          }}
        />
        <span className="user-menu-trigger-name">{name}</span>
        <ChevronDown size={16} aria-hidden="true" />
      </button>

      {isOpen && (
        <div className="user-menu-panel">
          <section className="user-menu-identity" aria-label="Identificación del Usuario">
            <img
              src={avatar}
              alt=""
              className="user-menu-avatar"
              onError={(event) => {
                event.currentTarget.onerror = null;
                event.currentTarget.src = defaultAvatar;
              }}
            />
            <div className="user-menu-identity-text">
              <p className="user-menu-name">{name}</p>
              <p className="user-menu-email">{email}</p>
              <p className="user-menu-role">{accountDescription}</p>
            </div>
          </section>

          {menuSections.map((section) => (
            <section className="user-menu-section" key={section.title}>
              <h2>{section.title}</h2>
              <div>
                {section.items.map(({ label, icon: Icon }) => (
                  label === "Seguridad" ? (
                    <button
                      type="button"
                      className="user-menu-item user-menu-action"
                      key={label}
                      onClick={() => {
                        setIsOpen(false);
                        setIsPasswordModalOpen(true);
                      }}
                    >
                      <Icon size={17} aria-hidden="true" />
                      <span>{label}</span>
                    </button>
                  ) : (
                    <div className="user-menu-item" key={label}>
                      <Icon size={17} aria-hidden="true" />
                      <span>{label}</span>
                    </div>
                  )
                ))}
              </div>
            </section>
          ))}

          <section className="user-menu-section user-menu-exit">
            <h2>Acción de Salida</h2>
            <LogOutMethod className="logout-gradient user-menu-logout">
              Cerrar Sesión
            </LogOutMethod>
          </section>
        </div>
      )}
      {isPasswordModalOpen && (
        <ChangePasswordModal onClose={() => setIsPasswordModalOpen(false)} />
      )}
    </div>
  );
};

export default UserMenu;
